import agent from '../agent';

const initialState = {
    tags_object: {
        tags: [],
        requested: false,
    },
};
export const timeline = {
    namespaced: true,
    state: initialState,
    getters: {
        tags_object: state => {
            return state.tags_object;
        },
    },
    actions: {
        getAllTags({ commit }, search = '') {
            commit('tagsRequested', true);
            return agent.Tag.getTags(search, 6)
                .then(response => {
                    commit('setTags', response.data);
                    return Promise.resolve(response.data);
                })
                .catch(error => {
                    return Promise.reject(error);
                });
        },
    },
    mutations: {
        setTags(state, tags) {
            state.tags_object.tags = tags;
        },
        tagsRequested(state, val) {
            state.tags_object.requested = val;
        },
    },
};
